import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import * as adminActions from '../redux/actions';
import * as eventActions from '../../event/redux/actions';
import { Table, DatePicker, Divider, Tabs, Button, Select, Input, Row, Col, Tag, Icon, Popconfirm, Spin, message } from 'antd';
import AdminLayout from '../AdminLayout';
import moment from 'moment';
import { STATUS, is, toTag, toStringDiffEvent } from './Constants';
import API, { CSV_URL } from '../../../helper/api/Api';

const TabPane = Tabs.TabPane;
const { Column } = Table;

export class Events extends Component {
  static propTypes = {
    admin: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    pagination: {},
    loading: false,
    search: null,
    date: null,
    categories: [],
    places: [],
    status: [],
    moderator: {
      list: [],
      users: [],
      isFetching: false
    },
  };

  componentWillMount() {
    this.props.actions.getEvents("ASC", { obsolete: 'True', moderators: 'True', categories: 'True' });
  }

  handleDate = (d, date) => {
    this.setState({ date: d, loading: true })
    if (date)
      this.props.actions.getEvents("ASC", { obsolete: 'True', moderators: 'True', categories: 'True', from: date }); //, to : date
    else
      this.props.actions.getEvents("ASC", { obsolete: 'True', moderators: 'True', categories: 'True' });
  }

  exportCsv = (eventId) => {
    API.getUserInEventAsCsvFile(eventId).then((res) => window.open(CSV_URL(res.data)));
  }

  table = (events, status = false) => {
    const data = events
      .filter(e => !this.state.search || e.title.toLowerCase().includes(this.state.search.toLowerCase()))
      .filter(e => this.state.places.length === 0 || this.state.places.includes(e.location.address))
      .filter(e => this.state.status.length === 0 || this.state.status.includes(is(e, true)))
      .filter(e => this.state.moderator.list.length === 0 || e.moderators.some(r => this.state.moderator.list.map(l => Number(l.key)).includes(Number(r.user.id))))
      .filter(e => this.state.categories.length === 0 || e.eventCategory.some(r => this.state.categories.includes(r.category.name)))

    return (
      <div className="ListEvents-content">
        <Table
          dataSource={data}
          loading={{ size: "small", spinning: this.props.event.status.getEvents.pending || this.props.event.status.deleteEvent.pending }}
          rowKey={(record) => record.id}
        >
          <Column
            title="Nom"
            dataIndex="title"
            key="title"
          />
          <Column
            title="Date"
            render={(text, r) => <span>{toStringDiffEvent(r)}</span>}
            key="Date"
          />
          <Column
            title="Lieu"
            render={(text, r) => {
              if (r.location)
                return (<span key={"eventLocation" + r.id}> {r.location.address} </span>);
              else
                return (<Tag key={"eventLocation" + r.id}>Aucun</Tag>);
            }}
            key="location"
          />
          <Column
            title="Catégories"
            dataIndex=""
            key="categories"
            render={(text, r) => {
              const result = [];
              if (r.eventCategory)
                for (let category of r.eventCategory)
                  result.push(<Tag key={"eventCategory" + category.category.id}>{category.category.name}</Tag>);

              return result;
            }}
          />
          {
            status ?
              <Column
                title="Status Inscription"
                dataIndex="status"
                render={(status, r) => {
                  const tag = toTag(is(r, true))

                  return (<Tag color={tag.color}>{tag.text}</Tag>);
                }}
                key="status"
              />
              :
              ''
          }
          <Column
            title="Inscription"
            key="Inscription"
            render={(text, r) => {
              if (r.subscribeNumber === 0)
                return "-";//<Tag color={toTag(is(r, true)).color}>{toTag(is(r, true)).text}</Tag>;
              else
                if (is(r) === STATUS.DONE)
                  return (<Link to={"/admin/events/presence/" + r.id}><Button type="default">{r.subscribedNumber} <Icon type="right" /></Button></Link>);
                else
                  return (<Link to={"/admin/events/registration/" + r.id}><Button type="primary">{r.subscribedNumber} / {r.subscribeNumber} <Icon type="right" /></Button></Link>);
            }}
          />
          <Column
            title="Actions"
            key="actions"
            render={(text, record) => (
              //TODO
              <span>
                {
                  STATUS.DONE === record.status ?
                    <Popconfirm placement="topLeft" title={"Etes vous sur de vouloir supprimer cet évenement ?"} onConfirm={() => this.props.actions.deleteEvent(record.id)} okText="Oui" cancelText="Non">
                      <Button type="danger">Supprimer <Icon type="delete" /></Button>
                    </Popconfirm>
                    :
                    <span>
                      <Link to={'/admin/events/update/' + record.id} ><Button type="dashed">Modifier <Icon type="edit" /></Button></Link>
                      <Divider type="vertical" />
                      <Popconfirm placement="topLeft" title={"Etes vous sur de vouloir supprimer cet évenement ?"} onConfirm={() => this.props.actions.deleteEvent(record.id)} okText="Oui" cancelText="Non">
                        <Button type="danger">Supprimer <Icon type="delete" /></Button>
                      </Popconfirm>
                    </span>
                }
                <Divider type="vertical" />
                <Button
                  icon="copy"
                  type="dashed"
                  onClick={() => {
                    message.loading("Copie en cours (sauf moderateurs / images)", 2);
                    this.props.actions.getEvent(record.id, { images: 'True', categories: 'True', moderators: 'True', prices: 'True', restricted: 'True' })
                      .then((res) => this.props.history.push('/admin/events/create', res.data))
                  }
                  }
                />
                <Divider type="vertical" />
                <Button
                  icon="export"
                  type="dashed"
                  title="exporter les utilisateurs"
                  onClick={() => {
                      this.props.actions.getEvent(record.id, { images: 'True', categories: 'True', moderators: 'True', prices: 'True', restricted: 'True' })
                        .then((res) => API.getUsers(res.data.event.id)
                          .then((userList) => API.post('/user/export/' + userList.join(','))
                            .then((res3) => window.open(CSV_URL(res3.data)))
                          )
                        )
                    }
                    }
                />
              </span>
            )}
          />
        </Table>
      </div>
    )
  }

  render() {
    //deep copy
    //.slice() doesn't work
    const events = JSON.parse(JSON.stringify(this.props.event.list));

    return (
      <AdminLayout
        title="ÉVÉNEMENTS"
        buttons={
          [
            {
              onClick: () => this.props.history.push('/admin/events/create'),
              icon: "plus",
              name: "AJOUTER UN ÉVÉNEMENT"
            }
          ]
        }
      >
        <div>
          <Row>
            <div className="admin-search-events" >
              <Col span={24} className="form-search-events">
                <Row className="input-search" type="flex" justify="space-between" style={{ marginBottom: '10px' }}>
                  <Col span={24} style={{ padding: '0 5px' }}>
                    <Input
                      placeholder="Recherche"
                      value={this.state.search}
                      onChange={(e) => this.setState({ search: e.target.value })}
                    />
                  </Col>
                </Row>
                <Row className="input-search" type="flex" justify="space-between">
                  <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 12 }} lg={{ span: 4 }} xl={{ span: 4 }} style={{ padding: '0 5px' }}>
                    <DatePicker style={{ width: '100%' }} value={this.state.date} onChange={this.handleDate} />
                  </Col>
                  <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 12 }} lg={{ span: 5 }} xl={{ span: 5 }} style={{ padding: '0 5px' }}>
                    <Select
                      showSearch
                      mode="multiple"
                      onChange={(categories) => this.setState({ categories })}
                      placeholder="Selectionner une catégorie"
                      style={{ display: 'block' }}
                    >
                      {
                        this.props.event.list
                          //filter existing
                          .filter((event) => event.eventCategory && event.eventCategory.length > 0)
                          //map every categories
                          .map((event) => event.eventCategory)
                          //build one table
                          .reduce((prev, acc) => prev.concat(acc), [])
                          //helper because of the damn API
                          .map(c => c.category)
                          //only uniq element
                          .filter((c, index, array) => index === array.findIndex((o) => o.id === c.id))
                          //UI
                          .map((c, index) => <Select.Option key={index} value={c.name}>{c.name}</Select.Option>)
                      }
                    </Select>
                  </Col>
                  <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 12 }} lg={{ span: 5 }} xl={{ span: 5 }} style={{ padding: '0 5px' }}>
                    <Select
                      showSearch
                      mode="multiple"
                      onChange={(places) => this.setState({ places })}
                      placeholder="Selectionner un lieu"
                      style={{ display: 'block' }}
                    >
                      {
                        [...new Set(
                          this.props.event.list
                            .filter((event) => event.location && event.location.address && event.location.address.length > 0)
                            .map((event) => event.location.address)
                        )].map((location, index) => <Select.Option key={index} value={location}>{location}</Select.Option>)
                      }
                    </Select>
                  </Col>
                  <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 12 }} lg={{ span: 5 }} xl={{ span: 5 }} style={{ padding: '0 5px' }}>
                    <Select
                      showSearch
                      mode="multiple"
                      onChange={(status) => this.setState({ status })}
                      placeholder="Selectionner un status"
                      style={{ display: 'block' }}
                    >
                      <Select.Option value={STATUS.DONE}>{toTag(STATUS.DONE).text}</Select.Option>
                      <Select.Option value={STATUS.COMING}>{toTag(STATUS.COMING).text}</Select.Option>
                      <Select.Option value={STATUS.ONGOING}>{toTag(STATUS.ONGOING).text}</Select.Option>
                      <Select.Option value={STATUS.FREE}>{toTag(STATUS.FREE).text}</Select.Option>
                      <Select.Option value={STATUS.FULL_FREE}>{toTag(STATUS.FULL_FREE).text}</Select.Option>
                    </Select>
                  </Col>
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 5 }} xl={{ span: 5 }} style={{ padding: '0 5px' }}>
                    <Select
                      mode="multiple"
                      labelInValue
                      placeholder="Selectionner un modérateur"
                      notFoundContent={this.state.isFetching ? <Spin size="small" /> : null}
                      filterOption={false}
                      onSearch={(search) => {
                        this.setState({ moderator: { ...this.state.moderator, users: [], isFetching: true } })
                        API.get('/user/all', { search })
                          .then((res) => this.setState({ moderator: { ...this.state.moderator, users: res.data, isFetching: false } }))
                          .catch((e) => this.setState({ moderator: { ...this.state.moderator, users: [], isFetching: false } }))
                      }}
                      onChange={(moderators) => {
                        this.setState({ moderator: { ...this.state.moderator, list: moderators, users: [] } })
                      }}
                      style={{ width: '100%' }}
                    >
                      {this.state.moderator.users.map(u => <Select.Option key={u.id}>{u.firstName} {u.lastName.toUpperCase()}</Select.Option>)}
                    </Select>
                  </Col>
                </Row>
              </Col>
            </div>
          </Row>
          <Row>
            <Tabs defaultActiveKey="1">
              <TabPane tab="Publiés" key="1">
                {this.table(events
                  .filter(e => [STATUS.COMING, STATUS.ONGOING, STATUS.PENDING, STATUS.SUBSCRIPTION].includes(is(e)))
                  , true)}
              </TabPane>
              <TabPane tab="Brouillons" key="2">
                {this.table(events
                  .filter(e => is(e) === STATUS.DRAFT)
                )}
              </TabPane>
              <TabPane tab="Passés" key="3">
                {this.table(events
                  .filter(e => is(e) === STATUS.DONE)
                )}
              </TabPane>
            </Tabs >
          </Row>
        </div>
      </AdminLayout>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    admin: state.admin,
    event: state.event
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...adminActions, ...eventActions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Events);



// WEBPACK FOOTER //
// ./src/features/admin/events/List.js